import React, { useEffect, useState } from "react";
import { Form, Table } from "react-bootstrap";
import UseToggle from "../../../../Hooks/UseToggle";
import SplitPane from "react-split-pane";
import ReportCategoryActivities from "./ReportCategoryActivities";
import AddNewReportCategory from "./AddNewReportCategory";
import { FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import UpdateReportCategory from "./UpdateReportCategory";
import { useParams } from "react-router";
import Pagination from "../../../Pagination";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Moment from "react-moment";
import Swal from "sweetalert2";
import { studyOnboardingService } from "../../../../APIServices/studyOnboarding";
import { CiSearch } from "react-icons/ci";
import DeletedReportCategory from "./DeletedReportCategory";
import { studyEDCLupReportingServices } from "../../../../APIServices/studyEDCLupReportingServices";

const ReportCategory = ({ onMouseDown, tableRef }) => {
  const { toggle1, setToggle1, toggle3, setToggle3 } = UseToggle();
  const [searchData, setSearchData] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [categoryData, setCategoryData] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [categoryCount, setCategoryCount] = useState(0);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [activeTab, setActiveTab] = useState("activities");
  const [activityLoader, setActivityLoader] = useState(false);
  const [categoryActivity, setCategoryActivity] = useState([]);
  const [categoryActivityCount, setCategoryActivityCount] = useState(0);
  const [categoryDeletedList, setCategoryDeletedList] = useState([]);
  const [categoryDeletedListCount, setCategoryDeletedListCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [isFormOpen, setIsFormOpen] = useState(false);
  let { studyId } = useParams();

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(categoryCount / itemsPerPage);

  const getLupReportCategorysData = async () => {
    setLoading(true)
    let data = await studyEDCLupReportingServices.getLupReportCategorysData(
      "active",
      studyId,
      searchData,
      pageNumber,
      itemsPerPage
    )
    setCategoryList(data?.data || []);
    setCategoryCount(data?.count || 0);
    setLoading(false)
  }

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getDeletedLupReportCategorysData = async (pageNumberDeleted) => {
    let data = await studyEDCLupReportingServices.getLupReportCategorysData(
      "deleted",
      studyId,
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setCategoryDeletedList(data?.data || []);
    setCategoryDeletedListCount(data?.count || 0);
  };

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  useEffect(() => {
    getLupReportCategorysData();
  }, [searchData, pageNumber, itemsPerPage]);

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "studyLupReportCategory",
      studyId,
      categoryId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setCategoryActivity(data?.data || []);
    setCategoryActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  const softDeleteRestoreLupReportCategory = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} category!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.id = id;
        userData.studyId = studyId;
        userData.type = type;
        let data =
          await studyEDCLupReportingServices.softDeleteRestoreLupReportCategory(
            userData
          );
        if (data?.statusCode === 200) {
          setCategoryId("")
          getLupReportCategorysData();
          getDeletedLupReportCategorysData();
          if (type === "restore") {
            getDeletedLupReportCategorysData(
              pageNumberDeleted,
              itemsPerPageDeleted
            );
            setToggle1();
          }
        }
      }
    });
  };

  return (
    <>
      <div
        className="justify-content-between toolbar border-bottom hstack p-1"
        style={{ height: 36 }}
      >
        <div className="hstack gap-1">
          <i
            title={isFormOpen ? "Close Form" : "Add New Category"}
            onClick={() => {
              setIsFormOpen(!isFormOpen);
              setCategoryId("");
            }}
            className={`fa-solid ${
              isFormOpen ? "fa-table-list" : "fa-plus-square CP"
            }`}
          />
          <div className="vr"></div>
          {categoryCount > 0 &&
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 200, padding: "3px 10px" }}
              ></Form.Control>
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 4, right: 7 }}
              />
            </div>
          }
        </div>
        {categoryDeletedListCount > 0 &&
          <button
            onClick={() => {
              setToggle1();
              getDeletedLupReportCategorysData(
                pageNumberDeleted,
                itemsPerPageDeleted
              );
            }}
            className={`updateProfile`}
          >
            Deleted History
          </button>
        }
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 184px)" }}
        minSize={categoryId ? "40%" : "100%"}
      >
       <SplitPane
          split="vertical"
          minSize={20}
          className="position-relative"
          defaultSize={isFormOpen ? "20%" : "100%"}
        >
          {isFormOpen && (
            <AddNewReportCategory getLupReportCategorysData={getLupReportCategorysData} />
          )}
          {loading ? (
            <PageLoader/>
          ) : categoryCount === 0 ? (
            <div className="hstack justify-content-center h-100">
              <NoDataFoundTable MSG="Category list not found" />
            </div>
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>Category Name</th>
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>
                      Last Updated Date |  Time
                    </th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 3)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Edit
                    </th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 4)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Delete
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {categoryList?.map((item, index) => (
                    <tr
                      key={item?._id || index}
                      className={`CP ${categoryId === item?.categoryId ? "highlighted" : ""}`}
                      title="View Details"
                      onClick={() => {
                        setCategoryData(item);
                        setCategoryId(item?.categoryId);
                        setIsFormOpen(false);
                      }}
                    >
                      <td className="text-center">{index + 1 + startIndex}</td>
                      <td>{item?.name}</td>
                      <td>
                        <Moment format="DD MMM YYYY | HH:mm" withTitle>
                          {item?.updatedAt}
                        </Moment>
                      </td>
                      <td
                        className="text-center"
                        title={`Update ${item?.categoryName}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          setCategoryData(item);
                          setToggle3();
                        }}
                      >
                        <FaEdit />
                      </td>
                      <td
                        className="text-center"
                        title={`Delete ${item?.categoryName}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          softDeleteRestoreLupReportCategory(item?._id, "delete");
                        }}
                      >
                        <FaTrash className="text-danger" />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={categoryCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </>
          )}
        </SplitPane>
        {categoryId && (
          <div className={isFullScreen ? "full-screen-component" : ""}>
            <div className="hstack paginate fixed_tab_button justify-content-between pt-1 border-bottom bg-light">
              <div className="hstack me-1 gap-1">
                {["activities"].map((tab) => (
                  <button
                    key={tab}
                    className={`buttonForTabs px-2 ${activeTab === tab ? "activee" : ""}`}
                    onClick={() => setActiveTab(tab)}
                    title={tab.charAt(0).toUpperCase() + tab.slice(1)}
                  >
                    {tab.charAt(0).toUpperCase() + tab.slice(1)}
                  </button>
                ))}
              </div>
              <div className="d-flex gap-1">
                <div className="toolbar">
                  <i
                    className="fa-solid fa-angle-down"
                    onClick={() => setCategoryId(false)}
                  ></i>
                </div>
                <div className="toolbar">
                  <i
                    className={`fa-solid me-2 ${!isFullScreen ? "fa-maximize" : "fa-minimize"
                      }`}
                    title={!isFullScreen ? "Full Mode" : "Original Mode"}
                    onClick={toggleFullScreen}
                  ></i>
                </div>
              </div>
            </div>
            {activeTab === "activities" && (
              <ReportCategoryActivities
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                categoryActivity={categoryActivity}
                activityLoader={activityLoader}
                getStudyAuditTrials={getStudyAuditTrials}
                categoryData={categoryData}
                categoryActivityCount={categoryActivityCount}
              />
            )}
          </div>
        )}
      </SplitPane>
      <UpdateReportCategory
        Show={!toggle3}
        Hide={setToggle3}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        Title={"Update Category"}
        categoryData={categoryData}
        setCategoryData={setCategoryData}
        setCategoryId={setCategoryId}
        getLupReportCategorysData={getLupReportCategorysData}
      />
      <DeletedReportCategory
        Show={!toggle1}
        Hide={setToggle1}
        studyId={studyId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        categoryDeletedList={categoryDeletedList}
        getDeletedLupReportCategorysData={getDeletedLupReportCategorysData}
        categoryDeletedListCount={categoryDeletedListCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        softDeleteRestoreLupReportCategory={softDeleteRestoreLupReportCategory}
        Title={"Deleted Category Metadata History"}
      />
    </>
  );
};

export default ReportCategory;
